import type {
  Address,
  CompanyCreationData,
  CreateCompanyCommandData,
} from '@festina/legalentity-general-types/legalentity'
import { typeUtils } from '@festina-life/core'
import {
  FormikFieldArray,
  FormikForm,
  FormikTextInput,
} from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { useComponent } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'

type FormType = CreateCompanyCommandData & {
  identificationCreationData: CompanyCreationData['identificationCreationData']
}

const validateKey = typeUtils.createValidator<FormType>()

export const CreateCompanyForm = ({
  commandActionVariant,
  ...props
}: CommandDataFormProps<FormType>) => {
  const translate = useTranslate()
  const AddressFields = useComponent('pages.personEntity.forms.AddressFields')

  return (
    <FormikForm
      initialValues={{
        _type: 'CreateCompanyCommandData',
        identificationCreationData: {
          _type: 'IdentificationCreationData',
          type: 'company',
        },
      }}
      {...props}
    >
      {commandActionVariant === 'create' && (
        <FormikTextInput
          name={validateKey('identificationCreationData.externalId')}
          label={translate('createCompany.companyId')}
        />
      )}
      <FormikTextInput
        name={validateKey('name')}
        label={translate('createCompany.name')}
      />
      <FormikFieldArray
        name={validateKey('addresses')}
        label={translate('createCompany.addresses')}
        elementLabel={translate('createCompany.address')}
        elementInitializer={() => ({ _type: 'Address' }) satisfies Address}
        ChildElement={AddressFields}
        childProps={{ addressType: null }} // addressType is optional from AddressFields
      />
    </FormikForm>
  )
}
